
let initialState = {
    siteEntered: false,
    productModal: false,
    designModal: false,
    microModal: false,
    cookieModal: false,
    checkoutModal: false,
    telephoneModal: false,
    galleryModal: false,
    contestModal: false,
    contestCarousel: false,
    landingVideoModal: false,
    cookiesAccepted: localStorage.getItem('OBD_Cookies') === 'true',
    exploring: false,
    topExit: false,
    videoActive: false,
    modalOpen: false,
    menuOpen: false
};

function DeviceReducer(state = initialState, action){
    switch (action.type) {
        case "SET_ACCESSIBLE":
            return {
                ...action.payload,
                modalOpen: action.payload.productModal || action.payload.designModal || action.payload.microModal ||
                    action.payload.cookieModal || action.payload.checkoutModal || action.payload.telephoneModal ||
                    action.payload.galleryModal || action.payload.landingVideoModal || action.payload.contestModal
            };

        default:
            return state;
    }
}

export default DeviceReducer;
